import { departamentoService } from "../service/departamento-service";
import { departamentoPadraoService } from "../service/departamento-padrao-service";

class DepartamentoUtils {
  constructor() {}

  converterDepartamentosEmDepartamentosDTO(departamentos) {
    const departamentosDTO = departamentos.map((departamento) => {
        return {
            value: departamento.value.toString(),
            label: departamento.label,
        };
    });

    return departamentosDTO;
  }

  async adquirirTodosOsDepartamentos() {
    const departamentos = await departamentoService.listar();
    const departamentosPadrao = await departamentoPadraoService.listar();

    const departamentosDTO = this.converterDepartamentosEmDepartamentosDTO(departamentos);

    const departamentosListados = departamentosDTO.concat(departamentosPadrao);

    return departamentosListados;
  }
}

export const departamentoUtils = new DepartamentoUtils();
